module.exports = __webpack_public_path__ + "img/capitol_map.532a287c.png";